<template>
  <v-form>
    <gg-text-field
      label="Name"
      name="Name"
      placeholder="Valid zone name"
      v-model="model.name"
      v-validate="rules.name"
      :error-messages="errors.collect('Name')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="TTL"
      name="TTL"
      placeholder="14400"
      v-model="model.ttl"
      v-validate="rules.ttl"
      :error-messages="errors.collect('TTL')"
      @input="sendData"></gg-text-field>
    <gg-input-label>Record</gg-input-label>
    <v-textarea
      outlined
      dense
      name="Record"
      rows="3"
      class="gg-input"
      placeholder="Text"
      v-model="model.txtdata"
      v-validate="rules.record"
      :error-messages="errors.collect('Record')"
      @input="sendData"></v-textarea>
  </v-form>
</template>

<script>
import { ZoneRecord } from '@/mixins/ZoneRecord'

export default {
  name: 'TXTRecordForm',
  mixins: [ZoneRecord],
  inject: ['parentValidator'],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: {
        name: '',
        ttl: '14400',
        txtdata: ''
      },
      rules: {
        name: { required: true },
        ttl: { required: true, numeric: true },
        record: { required: true }
      }
    }
  },
  methods: {
    fillEditData () {
      for (let key in this.item) {
        if (this.item.hasOwnProperty(key)) {
          this.model[key] = this.item[key]
        }
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
    if (this.edit) {
      this.fillEditData()
    }
    this.sendData()
  }
}
</script>
